import { Spinner } from '@epam/promo';
import { useAdminGetCurrent } from 'hooks/api/useAdminGetCurrent';
import { UserRole } from 'models/user.model';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const RequireUser = ({ allowedRoles }: { allowedRoles: UserRole[] }) => {
  const location = useLocation();
  const { user, isLoading } = useAdminGetCurrent();

  if (isLoading) {
    return <Spinner color="blue" />;
  }

  if (!user) {
    return <Navigate replace state={{ from: location }} to="/login" />;
  }

  return allowedRoles.includes(user.role) ? (
    <Outlet />
  ) : (
    <Navigate replace state={{ from: location }} to="/forbidden" />
  );
};
